(function() {
  document.addEventListener('click', function(e) {
    // Handle carousel button clicks
    var btn = e.target.closest('.card-carousel__btn');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();

      var carousel = btn.closest('.card-carousel');
      if (!carousel) return;

      var track = carousel.querySelector('.card-carousel__track');
      var total = carousel.querySelectorAll('.card-carousel__slide').length;
      var prevBtn = carousel.querySelector('.card-carousel__btn--prev');
      var nextBtn = carousel.querySelector('.card-carousel__btn--next');
      var dots = carousel.querySelectorAll('.card-carousel__dot');

      var current = parseInt(carousel.dataset.index || '0', 10);
      var next = btn.classList.contains('card-carousel__btn--next') ? current + 1 : current - 1;

      if (next < 0 || next >= total) return;

      carousel.dataset.index = next;
      track.style.transform = 'translateX(-' + (next * 100) + '%)';
      prevBtn.disabled = (next === 0);
      nextBtn.disabled = (next === total - 1);
      dots.forEach(function(dot, idx) {
        dot.classList.toggle('card-carousel__dot--active', idx === next);
      });
      return;
    }

    // Handle image clicks - navigate to product
    var slide = e.target.closest('.card-carousel__slide');
    if (slide && slide.dataset.href) {
      window.location.href = slide.dataset.href;
    }
  }, true);
})();
